import {useInfiniteQuery} from '@tanstack/react-query'
import {B2BMetricsRepository} from '../repositories/B2BMetricsRepository.ts'
import {AuthenticationRepository} from '../repositories/AuthenticationRepository.ts'

const b2bMetricsRepository = new B2BMetricsRepository(new AuthenticationRepository())

const PAGE_SIZE = 20

export function useAgencyTripbooksFeed(agencyId: string, enabled: boolean, isSelfService = false) {
    const query = useInfiniteQuery({
        queryKey: ['b2b-agency-tripbooks-feed', agencyId],
        queryFn: ({pageParam}) => b2bMetricsRepository.getB2BAgencyTripbooks(agencyId, PAGE_SIZE, pageParam, isSelfService),
        initialPageParam: 0,
        getNextPageParam: (lastPage, allPages) =>
            lastPage.tripbooks.length < PAGE_SIZE ? undefined : allPages.length * PAGE_SIZE,
        enabled: enabled && !!agencyId,
    })

    return {
        tripbooks: query.data?.pages.flatMap((page) => page.tripbooks) ?? [],
        isLoading: query.isLoading,
        isFetchingNextPage: query.isFetchingNextPage,
        hasNextPage: query.hasNextPage,
        loadMore: query.fetchNextPage,
    }
}
